/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    parent_id: number;
    page: number;
    size: number;
}

type IOutput = IElementInfo;

export const getElementList = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.GET_ELEMENT_LIST, data).then((res: IListResponse<IOutput>) => {
        return res;
    });
};

export const getElementListSync = fetchDataSync<IInput>(getElementList);
